<template>
  <vue-scroll>
    <rabbey-toolbox :filterables="false">
      <div class="mr-5">
        <el-select
          v-model="type"
          placeholder="Tipo"
          class="box-item"
          size="mini"
        >
          <el-option value="Cantidad">Cantidad</el-option>
          <el-option value="Monto">Monto</el-option>
        </el-select>
      </div>

      <div class="mr-5">
        <yearcomponent
          ref="yearSelector"
          @change="handleryear"
          :initial="2014"
          class="box-item"
          size="mini"
        />
      </div>
    </rabbey-toolbox>

    <el-row>
      <el-col>
        <el-card>
          <h3>CONTRATOS NUEVOS</h3>

          <RabbeyTable3
            ref="table_new"
            v-loading="table_new_loading"
            :columns="columnsNew"
            :data="contracsNew"
            :height="400"
            show-summary
            :summary-method="getSummaries"
          />
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <el-card>
          <h3>CONTRATOS CANCELADOS</h3>

          <RabbeyTable3
            ref="table_cancelled"
            v-loading="table_cancel_loading"
            :columns="columnsCancel"
            :data="contracsCancells"
            :height="400"
            show-summary
            :summary-method="getSummaries"
          />
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <el-card>
          <h3>CONTRATOS POR VENCER</h3>
          <RabbeyTable3
            ref="table_expire"
            v-loading="table_finish_loading"
            :columns="columnsSeller"
            :data="contracsFinish"
            :height="400"
            show-summary
            :summary-method="getSummaries"
          />
        </el-card>
      </el-col>
    </el-row>

    <!-- //drawer -->
    <detalles ref="detalles" />
  </vue-scroll>
</template>

<script>
import yearcomponent from "@/components/Global_System/YearsComponent";
import { formatMonto } from "@/utils";
import CancelHyperLink from "../../../../components/functionals/CancelHyperLink.vue";
import detalles from "../../../../views/modules/customer_service/reports/ContractDetails";
import RabbeyTable3 from "@/components/RabbeyTable3.vue";

export default {
  name: "CanceledContracts",
  components: {
    yearcomponent,
    detalles,
    RabbeyTable3
  },
  mounted() {
    const yearNow = new Date().getFullYear();
    this.$refs.yearSelector.$data.Year = yearNow;
    this.handleryear(yearNow);
  },
  data() {
    return {
      table_new_loading: false,
      table_cancel_loading: false,
      table_finish_loading: false,
      month: 0,
      config: { "show-summary": false },
      type: "Cantidad",
      year: 0,
      contracsFinish: [],
      contracsCancells: [],
      contracsNew: [],
      columnsNew: [
        {
          prop: "PersonName",
          label: "Vendedor",
          minWidth: 200,
          fixed: true
        },
        {
          prop: "January",
          label: "Enero",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 1,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "February",
          label: "Febrero",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 2,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "March",
          label: "Marzo",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 3,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "April",
          label: "Abril",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 4,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "May",
          label: "Mayo",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 5,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "June",
          label: "Junio",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 6,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "July",
          label: "Julio",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 7,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "August",
          label: "Agosto",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 8,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "September",
          label: "Septiembre",
          minWidth: 90,
          fixed: true,
          cellAtrrs: {
            mes: 9,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "October",
          label: "Octubre",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 10,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "November",
          label: "Noviembre",
          minWidth: 90,
          fixed: true,
          cellAtrrs: {
            mes: 11,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "December",
          label: "Diciembre",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 12,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "Totals",
          label: "Total",
          minWidth: 100,
          fixed: true,
          formatter: (row) => {
            let key = "Totals";
            if (this.getType() === "Monto") {
              key = `${key}Amount`;
            }
            return row[key];
          }
        }
      ],
      columnsCancel: [
        {
          prop: "PersonName",
          label: "Vendedor",
          minWidth: 200,
          fixed: true
        },
        {
          prop: "January",
          label: "Enero",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 1,
            tbl: "table_cancel",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "February",
          label: "Febrero",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 2,
            tbl: "table_cancel",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "March",
          label: "Marzo",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 3,
            tbl: "table_cancel",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "April",
          label: "Abril",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 4,
            tbl: "table_cancel",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "May",
          label: "Mayo",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 5,
            tbl: "table_cancel",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "June",
          label: "Junio",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 6,
            tbl: "table_cancel",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "July",
          label: "Julio",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 7,
            tbl: "table_cancel",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "August",
          label: "Agosto",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 8,
            tbl: "table_cancel",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "September",
          label: "Septiembre",
          minWidth: 90,
          fixed: true,
          cellAtrrs: {
            mes: 9,
            tbl: "table_cancel",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "October",
          label: "Octubre",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 10,
            tbl: "table_cancel",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "November",
          label: "Noviembre",
          minWidth: 90,
          fixed: true,
          cellAtrrs: {
            mes: 11,
            tbl: "table_cancel",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "December",
          label: "Diciembre",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 12,
            tbl: "table_cancel",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "Totals",
          label: "Total",
          minWidth: 100,
          fixed: true,
          formatter: (row) => {
            let key = "Totals";
            if (this.getType() === "Monto") {
              key = `${key}Amount`;
            }
            return row[key];
          }
        }
      ],
      columnsSeller: [
        {
          prop: "PersonName",
          label: "Vendedor",
          minWidth: 200,
          fixed: true
        },
        {
          prop: "January",
          label: "Enero",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 1,
            tbl: "table_seller",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "February",
          label: "Febrero",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 2,
            tbl: "table_seller",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "March",
          label: "Marzo",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 3,
            tbl: "table_seller",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "April",
          label: "Abril",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 4,
            tbl: "table_seller",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "May",
          label: "Mayo",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 5,
            tbl: "table_seller",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "June",
          label: "Junio",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 6,
            tbl: "table_seller",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "July",
          label: "Julio",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 7,
            tbl: "table_seller",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "August",
          label: "Agosto",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 8,
            tbl: "table_seller",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "September",
          label: "Septiembre",
          minWidth: 90,
          fixed: true,
          cellAtrrs: {
            mes: 9,
            tbl: "table_seller",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "October",
          label: "Octubre",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 10,
            tbl: "table_seller",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "November",
          label: "Noviembre",
          minWidth: 90,
          fixed: true,
          cellAtrrs: {
            mes: 11,
            tbl: "table_seller",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "December",
          label: "Diciembre",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 12,
            tbl: "table_seller",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "Totals",
          label: "Total",
          minWidth: 100,
          fixed: true,
          formatter: (row) => {
            let key = "Totals";
            if (this.getType() === "Monto") {
              key = `${key}Amount`;
            }
            return row[key];
          }
        }
      ]
    };
  },
  methods: {
    formatMonto,
    handleryear(_year) {
      this.year = _year;
      this.getContractToExpire();
      this.getContractsCancelled();
      this.getContractsNew();
    },

    OpenSelect(props) {
      this.$refs.detalles.show(props, this.year);
    },
    getType() {
      return this.type;
    },
    // Contratos por vencer
    getContractToExpire() {
      this.table_finish_loading = true;
      this.$http
        .get(
          `/api/SalesApi/ConctratsCanceledSummary?CompanyID=${
            this.currentCompany
          }&Year=${this.year}&Status=${0}`
        )
        .then((response) => {
          if (response.status === 200) {
            this.contracsFinish = response.data.Items;
          }
        })
        .finally(() => {
          this.table_finish_loading = false;
        });
    },
    //Contratos Cancelados
    getContractsCancelled() {
      this.table_cancel_loading = true;
      this.$http
        .get(
          `/api/SalesApi/ConctratsCanceledSummary?CompanyID=${
            this.currentCompany
          }&Year=${this.year}&Status=${1}`
        )
        .then((response) => {
          if (response.status === 200) {
            this.contracsCancells = response.data.Items;
          }
        })
        .finally(() => {
          this.table_cancel_loading = false;
        });
    },
    //Contratos nuevos
    getContractsNew() {
      this.table_new_loading = true;
      this.$http
        .get(
          `/api/SalesApi/ConctratsNewSummary?CompanyID=${this.currentCompany}&Year=${this.year}&month=${this.mes}&personCode='default'`
        )
        .then((response) => {
          if (response.status === 200) {
            this.contracsNew = response.data.Items;
          }
        })
        .finally(() => {
          this.table_new_loading = false;
        });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      const gType = this.getType();
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Totales";
          return;
        }
        const key =
          gType === "Monto" ? `${column.property}Amount` : column.property;

        const values = data.map((item) => Number(item[key]));
        if (!values.every((value) => isNaN(value))) {
          let total = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            }
          }, 0);

          if (gType === "Monto") {
            total = this.formatMonto(total);
          }

          sums[index] = total;
        } else {
          sums[index] = "N/A";
        }
      });
      return sums;
    }
  }
};
</script>

<style scoped>
.box-item {
  padding-left: 2px;
  padding-right: 10px;
}
.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
.box-card {
}
</style>
